import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import DatePicker from 'vue2-datepicker'
import {
  BasicSelect
} from 'vue-search-select'
import moment from 'moment'

export default {
	name: 'shipment-client-rule-details',
	components: {
		VueElementLoading,
		DatePicker
	},
	data: function() {
		return {
			showTable: false,
			isLoadingSearch: false,
			shippingid: "",
			shipmentDetails: [],
			clientDetails:[],
			hublist: []
		}
	},
	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
      if (date == null || date == '')
        return '-'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
	},
	mounted() {
		this.getHubList();
	},
	methods: {
		getHubList() {
      this.hublist = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          var HubDetails = result.data.ResponseData
          for (var i = 0; i < HubDetails.length; i++) {
            this.hublist.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
            })
          }
        }, error => {
          console.error(error)
        })
    },
		onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						return false;
					} else {
						this.loadShipmentDetails();
					}
				}).catch(() => {
					console.log('errors exist', this.errors);
				});
		},
		loadShipmentDetails() {
			this.isLoadingSearch = true
			this.input = {
				shippingId:this.shippingid
			}
			axios({
					method: 'POST',
					'url': apiUrl.allocateRuleapi_url + 'getShipmentClientRuleDetails',
					data:this.input,
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoadingSearch = false;
					var response = result.data
					if (response.ResultCode == 100) {
						if (response.ResponseData) {
							this.showTable = true;
							this.shipmentDetails = response.ResponseData;
							this.clientDetails = response.ShipmentDetails;
							var hubDetails = []
              for (var i = 0; i < this.hublist.length; i++) {
                hubDetails[this.hublist[i].value] = this.hublist[i].text;
              }
              if (this.clientDetails[0]) {
                if (this.clientDetails[0].currenthubid && hubDetails[this.clientDetails[0].currenthubid]) {
                  this.clientDetails[0].CurrentHubName = hubDetails[this.clientDetails[0].currenthubid];
                }
                if (this.clientDetails[0].finaldestinationhubid&& hubDetails[this.clientDetails[0].finaldestinationhubid]) {
                  this.clientDetails[0].FinalDestinationName = hubDetails[this.clientDetails[0].finaldestinationhubid];
                }
              }
							this.shipmentDetails.map(v=>Object.assign(v, {shippingid: this.shippingid}))
						}
					} else {
						this.shipmentDetails = {};
						this.showTable = false;
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					this.isLoadingSearch = false;
					console.log(error)
				})
		},
		resetForm() {
			this.shippingid = "";
			this.shipmentDetails = [];
			this.isLoadingSearch = false;
			this.showTable = false;
			this.$validator.reset();
			this.errors.clear();
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/ShipmentClientRule/ShipmentClientRule.js